module.exports = __webpack_public_path__ + "static/media/car-icon.7e06e2c3.png";